import { type Product } from "@jti/magento";
import { useGetCartItemsQuery, useGetCustomerCartIdQuery } from "@jti/store/slices/magentoApiSlice";

export const useCartItems = () => {
  const {
    data: cartId,
    isLoading: isLoadingCartId,
    isFetching: isFetchingCartId,
    error: cartIdError,
  } = useGetCustomerCartIdQuery();

  const cartIdValue = cartId?.customerCart?.id;

  const {
    data,
    isLoading: isLoadingCartItems,
    isFetching: isFetchingCartItems,
    error: cartItemsError,
  } = useGetCartItemsQuery({ cartId: cartIdValue! }, { skip: !cartIdValue || !!isLoadingCartId || !!cartIdError });

  const isLoading = !!isLoadingCartId || !!isLoadingCartItems;
  const isFetching = isFetchingCartId || isFetchingCartItems;
  const error = cartIdError || cartItemsError;

  return { data: (data?.items ?? []) as Product[], isLoading, isFetching, error };
};
